import { HttpContext } from '@angular/common/http';
import { defer, fromEvent, Observable, throwError } from 'rxjs';
import { takeUntil, throwIfEmpty } from 'rxjs/operators';
import { TOO_MANY_REQUESTS_RETRIES } from '../tv4_app.module/interceptors/StandardResponseInterceptor';

export interface EstimateRequestOptions {
  requestNumber?: number;
  signal?: AbortSignal;
}

let latestRequestNumber = 0;

// Identifies this page load. The server tracks request numbers per client id, so the numbers only need
// to increase within one page load, and tabs don't supersede each other.
export const estimateClientId = crypto.randomUUID();

// The server refuses an estimate while too many are running for the user and campaign, and superseded
// estimates can take several seconds to stop. Retrying keeps the latest edit from failing meanwhile.
export function estimateHttpContext(): HttpContext {
  return new HttpContext().set(TOO_MANY_REQUESTS_RETRIES, 10);
}

export function nextEstimateRequestNumber(): number {
  return ++latestRequestNumber;
}

// Unsubscribing aborts the HTTP request. Errors with the abort reason so that callers always settle.
export function abortable<T>(request$: Observable<T>, signal?: AbortSignal): Observable<T> {
  if (!signal) return request$;
  return defer(() =>
    signal.aborted
      ? throwError(() => signal.reason)
      : request$.pipe(
          takeUntil(fromEvent(signal, 'abort')),
          throwIfEmpty(() => signal.reason),
        ),
  );
}
